export const COUNTRY_BRASIL_ID = 1;
